import { Form, Input, InputNumber, Select } from 'antd'
import React from 'react'
import styles from './styles.module.scss'
import InputField from '../common/Input/InputField'
import SelectField from '../common/Select/SelectField'
import { removeVietnameseTones } from '../../config-func'
const customizeRequiredMark = (label, { required }) => (
  <>
    {label}
    {required && <span style={{ color: 'red' }}> *</span>}
  </>
)
const FormPost = ({
  form,
  handleSearch,
  cities,
  districts,
  towns,
  onChangeCity,
  onChangeDistrict
}) => {
  return (
    <Form
      form={form}
      onFinish={handleSearch}
      labelAlign="left"
      labelCol={{ span: 8 }}
      layout="horizontal"
      style={{
        marginTop: 10,
        overflow: 'auto',
        overflowX: 'hidden',
        padding: '0px 10px'
      }}
      requiredMark={customizeRequiredMark}
      onValuesChange={(value, allValues) =>
        console.log('Form Data', value, allValues)
      }
    >
      <Form.Item label="" name="id" style={{ display: 'none' }}>
        <Input />
      </Form.Item>

      <Form.Item label="Dự án" name="project_name" rules={[{ required: true, message: 'Vui lòng chọn dự án' }]}>
        <Input placeholder="Nhập tên dự án" />
      </Form.Item>

      <Form.Item label="Vị trí/Địa chỉ"  name="address" rules={[{ required: true, message: 'Vui lòng nhập vị trí/địa chỉ' }]}>
        <Input placeholder="Nhập vị trí/địa chỉ" />
      </Form.Item>

        <Form.Item label="Tỉnh/Thành phố" name="city_code" rules={[{ required: true, message: 'Vui lòng chọn tỉnh/thành phố' }]}>
          <Select
            onChange={onChangeCity}
            allowClear
            showSearch
            placeholder="Chọn tỉnh/thành phố"
            optionFilterProp="children"
                filterOption={(input, option) => {
                  const inputValue = removeVietnameseTones(input).toLowerCase();
                  const optionValue = removeVietnameseTones(option?.children || '').toLowerCase();
                  return optionValue.includes(inputValue);
                }}
          >
            {cities.map((item) => {
                return (
                  <Select.Option key={item.value} value={item.value}>
                    {item.label}
                  </Select.Option>
                )
              })}
          </Select>
        </Form.Item>

      <Form.Item label="Quận/Huyện" name="district_code" rules={[{ required: true, message: 'Vui lòng chọn quận/huyện' }]}>
        <Select
          onChange={onChangeDistrict}
          placeholder="Chọn quận/huyện"
          allowClear
          showSearch
          optionFilterProp="children"
              filterOption={(input, option) => {
                const inputValue = removeVietnameseTones(input).toLowerCase();
                const optionValue = removeVietnameseTones(option?.children || '').toLowerCase();
                return optionValue.includes(inputValue);
              }}
        >
          {districts.map((item) => {
              return (
                <Select.Option key={item.value} value={item.value}>
                  {item.label}
                </Select.Option>
              )
            })}
        </Select>
      </Form.Item>

      <Form.Item label={`Phường/Xã`} name="town_code" rules={[{ required: true, message: 'Vui lòng chọn phường/xã/thị trấn' }]}>
        <Select
          placeholder="Chọn phường/xã"
          allowClear
          showSearch
          optionFilterProp="children"
              filterOption={(input, option) => {
                const inputValue = removeVietnameseTones(input).toLowerCase();
                const optionValue = removeVietnameseTones(option?.children || '').toLowerCase();
                return optionValue.includes(inputValue);
              }}
        >
          {towns.map((item) => {
              return (
                <Select.Option key={item.value} value={item.value}>
                  {item.label}
                </Select.Option>
              )
            })}
        </Select>
      </Form.Item>

      <Form.Item label="Chủ đầu tư" name="investor" rules={[{ required: true, message: 'Vui lòng nhập chủ đầu tư' }]}>
        <Input placeholder="Nhập chủ đầu tư" />
      </Form.Item>
      <Form.Item label="Số tầng" name="number_of_floor">
        <InputNumber placeholder="Nhập số tầng" style={{width: '100%'}}/>
      </Form.Item>
    </Form>
  )
}

export default FormPost
